import React from "react";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { v4 as uuidv4 } from "uuid";
import PageTitle from "../../general/pageTitle";
import CalendarForm, {
  defaultCalendarValues,
  reindexTerms,
} from "./CalendarForm";
import { saveCalendar } from "../../../services/calendarServices";

const validationSchema = yup.object().shape({
  year: yup.string().required("Academic year is required"),
  info: yup.string().required("Info label is required"),
  sortOrder: yup.number().min(1).required("Display order is required"),
  terms: yup
    .array()
    .of(
      yup.object().shape({
        sem: yup.string().required("Semester name is required"),
        calendar: yup
          .array()
          .of(
            yup.object().shape({
              opp: yup.string().required("Operation is required"),
              beginDate: yup.string().required("Beginning date is required"),
            })
          )
          .min(1, "Add at least one calendar row"),
      })
    )
    .min(1, "Add at least one semester"),
});

function CalendarEntry() {
  const navigate = useNavigate();

  return (
    <div>
      <PageTitle title="Add academic calendar" subTitle="calendar" />
      <div className="flex flex-col justify-center p-4">
        <Formik
          initialValues={defaultCalendarValues}
          validationSchema={validationSchema}
          onSubmit={async (values, actions) => {
            try {
              await saveCalendar({
                calendarId: uuidv4(),
                ...values,
                terms: reindexTerms(values.terms),
                status: "published",
              });
              navigate("/mycalendar");
            } catch (err) {
              actions.setSubmitting(false);
              alert(
                "Failed to save calendar. Ensure the backend /api/calendar endpoint is implemented."
              );
            }
          }}
        >
          {(formik) => (
            <CalendarForm
              title="Create academic calendar"
              cancelPath="/mycalendar"
              {...formik}
            />
          )}
        </Formik>
      </div>
    </div>
  );
}

export default CalendarEntry;
